import React, { FC } from 'react';
import { SkeletonSquare } from '@fiverr-private/feedback';
import { Thumbnail, Variant } from './Thumbnail';

export interface ThumbnailSkeletonProps {
  variant?: Variant;
  index?: number;
  isLast?: boolean;
}

export const ThumbnailSkeleton: FC<ThumbnailSkeletonProps> = ({ variant, index, isLast }) => (
  <Thumbnail isLast={isLast} variant={variant} index={index}>
    <SkeletonSquare width="100%" height="100%" />
  </Thumbnail>
);
